import { featureToggles, IS_APP } from '@otto-ec/eprivacy-shared'

if (!(IS_APP && featureToggles('cb_no_load_in_app_context', false))) {
  /*                                           */
  /*                                     */
  void import('./bootstrap').then(({ bootstrap }) => bootstrap())
}
